import {
  FETCH_CARE_ROUND,
  FETCH_CARE_ROUND_SUCCESS,
  FETCH_CARE_ROUND_FAILURE,
  ADD_CARE_ROUND,
  ADD_CARE_ROUND_SUCCESS,
  ADD_CARE_ROUND_FAILURE,
  FETCH_CARE_ROUND_ITEM,
  FETCH_CARE_ROUND_ITEM_SUCCESS,
  FETCH_CARE_ROUND_ITEM_FAILURE,
  FETCH_CARE_ROUND_REPORT,
  FETCH_CARE_ROUND_REPORT_SUCCESS,
  FETCH_CARE_ROUND_REPORT_FAILURE,
  FETCH_CARE_ROUND_NEXT_TWO_DAYS_SUMMARY,
  FETCH_CARE_ROUND_NEXT_TWO_DAYS_SUMMARY_SUCCESS,
  FETCH_CARE_ROUND_NEXT_TWO_DAYS_SUMMARY_FAILURE,
  FETCH_CARE_ROUND_OCCURRENCE_REPORT,
  FETCH_CARE_ROUND_OCCURRENCE_REPORT_SUCCESS,
  FETCH_CARE_ROUND_OCCURRENCE_REPORT_FAILURE,
  EDIT_CARE_ROUND,
  EDIT_CARE_ROUND_SUCCESS,
  EDIT_CARE_ROUND_FAILURE,
  DELETE_CARE_ROUND,
  DELETE_CARE_ROUND_SUCCESS,
  DELETE_CARE_ROUND_FAILURE,
  SET_CARE_ROUND_ADD_EDIT_MODAL,
  FETCH_FACILITY_DAILY_REPORT,
  FETCH_FACILITY_DAILY_REPORT_SUCCESS,
  FETCH_FACILITY_DAILY_REPORT_FAILURE,
  FETCH_FACILITY_TWICE_DAILY_REPORT,
  FETCH_FACILITY_TWICE_DAILY_REPORT_SUCCESS,
  FETCH_FACILITY_TWICE_DAILY_REPORT_FAILURE,
  FETCH_FACILITY_WEEKLY_REPORT,
  FETCH_FACILITY_WEEKLY_REPORT_SUCCESS,
  FETCH_FACILITY_WEEKLY_REPORT_FAILURE,
  FETCH_FACILITY_INTERVAL_REPORT,
  FETCH_FACILITY_INTERVAL_REPORT_SUCCESS,
  FETCH_FACILITY_INTERVAL_REPORT_FAILURE,
  MARK_ROUND_TASK_COMPLETION,
  MARK_ROUND_TASK_COMPLETION_SUCCESS,
  MARK_ROUND_TASK_COMPLETION_FAILURE,
  SAVE_ROUND_DATE_ASSIGNMENT,
  SAVE_ROUND_DATE_ASSIGNMENT_SUCCESS,
  SAVE_ROUND_DATE_ASSIGNMENT_FAILURE,
  FETCH_ROUND_ASSIGNMENT_SUMMARY,
  FETCH_ROUND_ASSIGNMENT_SUMMARY_SUCCESS,
  FETCH_ROUND_ASSIGNMENT_SUMMARY_FAILURE,
} from "./constants";

export const fetchCareRound = (payload) => ({
  type: FETCH_CARE_ROUND,
  payload,
});
export const fetchCareRoundSuccess = (payload) => ({
  type: FETCH_CARE_ROUND_SUCCESS,
  payload,
});
export const fetchCareRoundFailure = (payload) => ({
  type: FETCH_CARE_ROUND_FAILURE,
  payload,
});

export const addCareRound = (payload) => ({
  type: ADD_CARE_ROUND,
  payload,
});
export const addCareRoundSuccess = (payload) => ({
  type: ADD_CARE_ROUND_SUCCESS,
  payload,
});
export const addCareRoundFailure = (payload) => ({
  type: ADD_CARE_ROUND_FAILURE,
  payload,
});

export const fetchCareRoundItem = (payload) => ({
  type: FETCH_CARE_ROUND_ITEM,
  payload,
});
export const fetchCareRoundItemSuccess = (payload) => ({
  type: FETCH_CARE_ROUND_ITEM_SUCCESS,
  payload,
});
export const fetchCareRoundItemFailure = (payload) => ({
  type: FETCH_CARE_ROUND_ITEM_FAILURE,
  payload,
});

export const fetchCareRoundReport = (payload) => ({
  type: FETCH_CARE_ROUND_REPORT,
  payload,
});
export const fetchCareRoundReportSuccess = (payload) => ({
  type: FETCH_CARE_ROUND_REPORT_SUCCESS,
  payload,
});
export const fetchCareRoundReportFailure = (payload) => ({
  type: FETCH_CARE_ROUND_REPORT_FAILURE,
  payload,
});

export const fetchCareRoundNextTwoDaysSummary = (payload) => ({
  type: FETCH_CARE_ROUND_NEXT_TWO_DAYS_SUMMARY,
  payload,
});
export const fetchCareRoundNextTwoDaysSummarySuccess = (payload) => ({
  type: FETCH_CARE_ROUND_NEXT_TWO_DAYS_SUMMARY_SUCCESS,
  payload,
});
export const fetchCareRoundNextTwoDaysSummaryFailure = (payload) => ({
  type: FETCH_CARE_ROUND_NEXT_TWO_DAYS_SUMMARY_FAILURE,
  payload,
});

export const fetchCareRoundOccurrenceReport = (payload) => ({
  type: FETCH_CARE_ROUND_OCCURRENCE_REPORT,
  payload,
});
export const fetchCareRoundOccurrenceReportSuccess = (payload) => ({
  type: FETCH_CARE_ROUND_OCCURRENCE_REPORT_SUCCESS,
  payload,
});
export const fetchCareRoundOccurrenceReportFailure = (payload) => ({
  type: FETCH_CARE_ROUND_OCCURRENCE_REPORT_FAILURE,
  payload,
});

export const editCareRound = (payload) => ({
  type: EDIT_CARE_ROUND,
  payload,
});
export const editCareRoundSuccess = (payload) => ({
  type: EDIT_CARE_ROUND_SUCCESS,
  payload,
});
export const editCareRoundFailure = (payload) => ({
  type: EDIT_CARE_ROUND_FAILURE,
  payload,
});

export const deleteCareRound = (payload, onDelete) => ({
  type: DELETE_CARE_ROUND,
  payload,
  onDelete,
});
export const deleteCareRoundSuccess = (payload) => ({
  type: DELETE_CARE_ROUND_SUCCESS,
  payload,
});
export const deleteCareRoundFailure = (payload) => ({
  type: DELETE_CARE_ROUND_FAILURE,
  payload,
});

export const setCareRoundAddEditModal = (payload) => ({
  type: SET_CARE_ROUND_ADD_EDIT_MODAL,
  payload,
});

export const fetchFacilityDailyReport = (payload) => ({
  type: FETCH_FACILITY_DAILY_REPORT,
  payload,
});
export const fetchFacilityDailyReportSuccess = (payload) => ({
  type: FETCH_FACILITY_DAILY_REPORT_SUCCESS,
  payload,
});
export const fetchFacilityDailyReportFailure = () => ({
  type: FETCH_FACILITY_DAILY_REPORT_FAILURE,
});

export const fetchFacilityTwiceDailyReport = (payload) => ({
  type: FETCH_FACILITY_TWICE_DAILY_REPORT,
  payload,
});
export const fetchFacilityTwiceDailyReportSuccess = (payload) => ({
  type: FETCH_FACILITY_TWICE_DAILY_REPORT_SUCCESS,
  payload,
});
export const fetchFacilityTwiceDailyReportFailure = () => ({
  type: FETCH_FACILITY_TWICE_DAILY_REPORT_FAILURE,
});

export const fetchFacilityWeeklyReport = (payload) => ({
  type: FETCH_FACILITY_WEEKLY_REPORT,
  payload,
});
export const fetchFacilityWeeklyReportSuccess = (payload) => ({
  type: FETCH_FACILITY_WEEKLY_REPORT_SUCCESS,
  payload,
});
export const fetchFacilityWeeklyReportFailure = () => ({
  type: FETCH_FACILITY_WEEKLY_REPORT_FAILURE,
});

export const fetchFacilityIntervalReport = (payload) => ({
  type: FETCH_FACILITY_INTERVAL_REPORT,
  payload,
});
export const fetchFacilityIntervalReportSuccess = (payload) => ({
  type: FETCH_FACILITY_INTERVAL_REPORT_SUCCESS,
  payload,
});
export const fetchFacilityIntervalReportFailure = () => ({
  type: FETCH_FACILITY_INTERVAL_REPORT_FAILURE,
});

// payload: { roundId, taskId, isCompleted, isSkipped, residentId?, scheduledAt?, notes? }
// onSuccess is always called; result is null on failure so the caller can clear loading state
export const markRoundTaskCompletion = (payload, onSuccess) => ({
  type: MARK_ROUND_TASK_COMPLETION,
  payload,
  onSuccess,
});
export const markRoundTaskCompletionSuccess = (payload) => ({
  type: MARK_ROUND_TASK_COMPLETION_SUCCESS,
  payload,
});
export const markRoundTaskCompletionFailure = () => ({
  type: MARK_ROUND_TASK_COMPLETION_FAILURE,
});

// payload: { roundId, assignments: [{ assignedDate, actualEmployeeIds }] }
// onSuccess called with API result on success; onFailure called on error
export const saveRoundDateAssignment = (payload, onSuccess, onFailure) => ({
  type: SAVE_ROUND_DATE_ASSIGNMENT,
  payload,
  onSuccess,
  onFailure,
});
export const saveRoundDateAssignmentSuccess = (payload) => ({
  type: SAVE_ROUND_DATE_ASSIGNMENT_SUCCESS,
  payload,
});
export const saveRoundDateAssignmentFailure = () => ({
  type: SAVE_ROUND_DATE_ASSIGNMENT_FAILURE,
});

// payload: { location_id, from_date, to_date }
export const fetchRoundAssignmentSummary = (payload) => ({
  type: FETCH_ROUND_ASSIGNMENT_SUMMARY,
  payload,
});
export const fetchRoundAssignmentSummarySuccess = (payload) => ({
  type: FETCH_ROUND_ASSIGNMENT_SUMMARY_SUCCESS,
  payload,
});
export const fetchRoundAssignmentSummaryFailure = () => ({
  type: FETCH_ROUND_ASSIGNMENT_SUMMARY_FAILURE,
});
